import { render } from "./TagList.vue?vue&type=template&id=5ad9fad2"
import script from "./TagList.vue?vue&type=script&lang=ts"
export * from "./TagList.vue?vue&type=script&lang=ts"
script.render = render

export default script